import { render, staticRenderFns } from "./deanAccordion.vue?vue&type=template&id=7645a006&scoped=true"
import script from "./deanAccordion.vue?vue&type=script&lang=ts"
export * from "./deanAccordion.vue?vue&type=script&lang=ts"
import style0 from "./deanAccordion.vue?vue&type=style&index=0&id=7645a006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7645a006",
  null
  
)

export default component.exports